// Draft comments in Dexie are the only copy of a reviewer's unpublished work, and an installed PWA
// that stays open for weeks is exactly the case where the browser starts evicting under disk
// pressure. This asks the browser not to. It is no defence against the user clearing site data.
export async function requestPersistentStorage(): Promise<boolean> {
  if (!navigator.storage?.persist) return false;
  try {
    if (await navigator.storage.persisted()) return true;
    return await navigator.storage.persist();
  } catch {
    return false;
  }
}
